import { Link } from "gatsby"

import React from "react"

import "./breadcrumbs.css"
class Breadcrumbs extends React.Component {
  render() {
     return (
            <div className="Breadcrumbs">
               <ul>
                  <li> <Link to="/">Home </Link> </li>
                  <li> <span>/</span> </li>
                  {this.props.pageTitle && <li>{this.props.pageTitle}</li>}
                  
               </ul>
            </div>
      )
  }
}



export default Breadcrumbs
